import React from 'react';

const Card = ({ 
  title = 'Card Title',
  description = 'Card description goes here',
  image = '',
  link = '',
  className = '' 
}) => {
  const Wrapper = link ? 'a' : 'div';
  const wrapperProps = link ? { href: link } : {};

  return (
    <Wrapper 
      {...wrapperProps}
      className={`block bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-shadow ${className}`}
    >
      {image && (
        <div className="aspect-video overflow-hidden">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
    </Wrapper>
  );
};

Card.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Card Title',
    },
    description: {
      type: 'textarea',
      label: 'Description',
      default: 'Card description goes here',
    },
    image: {
      type: 'image',
      label: 'Image',
      default: '',
    },
    link: {
      type: 'text',
      label: 'Link URL',
      default: '',
    },
  },
};

export default Card;
